import React from 'react';
import PropTypes from 'prop-types';
import toast, { Toaster as AlertBase, ToastPositions } from '../toast';
import './alert.scss';
import BadgeGroup, { BadgeGroupSizes, BadgeGroupTypes } from '../badge-group';
import Button, { ButtonTypes } from '../button';

const DEFAULT_DURATION = Infinity;

const AlertTypes = {
  PRIMARY: 'alert-primary',
};

const Alert = ({
  thisToast, type, bgText, bgMessage, supportingText, link, linkButtonLabel,
}) => {
  const getBody = () => {
    switch (type) {
      case AlertTypes.PRIMARY:
        return (
          <div className="alert-body">
            <BadgeGroup
              text={bgText}
              message={bgMessage}
              type={BadgeGroupTypes.PRIMARY}
              size={BadgeGroupSizes.LARGE}
              className="alert-bg-cont"
            />
            <div className="alert-supporting-text">{supportingText}</div>
          </div>
        );
      default:
        return null;
    }
  };

  const getLinkButton = () => (link ? (
    <a href={link} target="_blank" rel="noreferrer">
      <Button
        label={linkButtonLabel}
        type={ButtonTypes.LINK}
        className="alert-button"
      />
    </a>
  ) : null);

  const getDismissButton = () => (
    <Button
      label="DISMISS"
      onClick={() => toast.dismiss(thisToast.id)}
      type={ButtonTypes.LINK}
      className="alert-button"
    />
  );

  return (
    <div className={`alert-cont ${type}`}>
      {getBody()}
      {getLinkButton()}
      {getDismissButton()}
    </div>
  );
};

Alert.propTypes = {
  thisToast: PropTypes.shape({ id: PropTypes.string }),
  type: PropTypes.oneOf(Object.values(AlertTypes)),
  bgText: PropTypes.string,
  bgMessage: PropTypes.string,
  supportingText: PropTypes.string,
  link: PropTypes.string,
  linkButtonLabel: PropTypes.string,
};

Alert.defaultProps = {
  thisToast: {},
  type: AlertTypes.PRIMARY,
  bgText: '',
  bgMessage: '',
  supportingText: '',
  link: '',
  linkButtonLabel: 'LEARN_MORE',
};

const commonToastProperties = {
  duration: DEFAULT_DURATION,
  position: ToastPositions.TOP_CENTER,
  className: 'alert-toast',
  ariaProps: {
    className: 'alert-toast-aria',
  },
};

const alert = {
  primary: (bgText, bgMessage, supportingText, link, linkButtonLabel) => toast((t) => (
    <Alert
      thisToast={t}
      bgText={bgText}
      bgMessage={bgMessage}
      supportingText={supportingText}
      link={link}
      linkButtonLabel={linkButtonLabel}
      type={AlertTypes.PRIMARY}
    />
  ), {
    ...commonToastProperties,
  }),
  dismiss: (id) => toast.dismiss(id),
  remove: (id) => toast.remove(id),
};

export {
  alert as default,
  AlertBase,
  AlertTypes,
};
